import {ActionButton} from "../../../../designSystem/components/ActionButton";
import React from "react";
import {GROUPS} from "../../../../utils/constants";
import {BaseInput} from "../../../../designSystem/components/BaseInput";
import {OptionButton} from "../../../../designSystem/components/OptionButton";
import {Typography} from "../../../../designSystem/components/Typography";

export const OrganizationForm = ({
  organization,
  onChangeName,
  mode,
  onClickSave,
  onChangeGroup,
  userRole,
  userOrganizationGroup
}) => (
  <div className="p-8 flex flex-col gap-4">
    <Typography variant="title">
      {mode ? '編輯業務組別' : '新增業務組別'}
    </Typography>
    <BaseInput
      label="名稱"
      placeholder="名稱"
      value={organization.name}
      onChange={onChangeName}
    />

    <div className="flex flex-col gap-2">
      <Typography variant="bodyBold">
        組別
      </Typography>
      <div className="flex flex-1 flex-row flex-wrap items-start gap-2">
        {GROUPS
          .filter(group => {
            if (userRole === 'god') return true
            return userOrganizationGroup.includes(group.name)
          })
          .map((group) => (
            <OptionButton
              key={group.name}
              onClick={() => onChangeGroup(group.name)}
              icon={group.icon}
              label={group.name}
              isSelected={organization.group.includes(group.name)}
            />
          ))
        }
      </div>
    </div>
    <div className="mt-8">
      <ActionButton
        label={mode ? "儲存變更" : "確定新增"}
        iconName={mode ? "fa-save" : "fa-check"}
        onClick={onClickSave}
        fullWidth
        disabled={!organization.name || organization.group?.length === 0}
      />
    </div>
  </div>
)
